module.exports = __webpack_public_path__ + "0aa22d0f3a8c1a3eeb6d9ea7eb57c55f.jpg";